$(document).ready(function(){
  const loadProductDetails = (productJson,productId,$this) => {
    //console.log(productJson);
    //console.log(productId);
    //     console.log((productJson.title).split("|")[1])

    //     let gridItem = $(`.collection-new-grid-item[data-product-id='${productId}']`);

    let gridItem = $this.parents(`.collection-new-grid-item`);

    gridItem.find(".color-swatch__option-title").text(`${(productJson.title).split("|")[1]}`);

    gridItem.find(".product-title").text(`${(productJson.title).split("|")[0]}`);

    let price = productJson.price - 2000;
    let mainPrice = theme.Shopify.formatMoney(price,theme.money_format)
    gridItem.find(".theme-money").text(`${(theme.Shopify.formatMoney(price,theme.money_format)).replace(".00", "")} + ${(theme.Shopify.formatMoney(2000,theme.money_format)).replace(".00", "")} Recycling Credit`);


    /* For Image */
    const getPadding = (aspectRatio)=>{
      let padding = 1;
      return ((padding / aspectRatio)* 100 )
    }
    let firstImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${productJson.media[0].width} px">
<div class="rimage-wrapper " style="padding-top:${getPadding(productJson.media[0].aspect_ratio)}%">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""
data-srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${productJson.media[0].src}_1024x1024.png?v=1626405866" alt="${productJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
    gridItem.find(".image__first").empty().append(firstImageHtml);

    if(productJson.media[1]){
      let secondImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${productJson.media[1].width} px">
<div class="rimage-wrapper " style="${getPadding(productJson.media[1].aspect_ratio)}">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""
data-srcset="${productJson.media[1].src}_720x.png?v=1626405866 720w, ${productJson.media[1].src}_900x.png?v=1626405866 900w, ${productJson.media[1].src}_1080x.png?v=1626405866 1080w, ${productJson.media[1].src}_1296x.png?v=1626405866 1296w, ${productJson.media[1].src}_1512x.png?v=1626405866 1512w, ${productJson.media[1].src}_1728x.png?v=1626405866 1728w, ${productJson.media[1].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${productJson.media[1].src}_720x.png?v=1626405866 720w, ${productJson.media[1].src}_900x.png?v=1626405866 900w, ${productJson.media[1].src}_1080x.png?v=1626405866 1080w, ${productJson.media[1].src}_1296x.png?v=1626405866 1296w, ${productJson.media[1].src}_1512x.png?v=1626405866 1512w, ${productJson.media[1].src}_1728x.png?v=1626405866 1728w, ${productJson.media[1].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${productJson.media[1].src}_1024x1024.png?v=1626405866" alt="${productJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
      gridItem.find(".image__second").empty().append(secondImageHtml);
    }

  }

  $(document).on("click", ".color-option-selector", function(){
    let currentBtn = $(this);
    let productHandle = $(this).data("handle");
    let productId = $(this).data("id");
    currentBtn.parents(".color-swatch__option-inner-container").find(".color-swatch__option").removeClass("active");
    currentBtn.parent(".color-swatch__option").addClass("active");
    let productJson = JSON.parse($(`#product_json-${productHandle}`).html());
    if(productJson){
      //       console.log(productJson);
      let newGridUrl = `/products/${productJson.handle}`
      currentBtn.parents(".product-block__inner").find("a.image-inner").attr("href", newGridUrl);
      loadProductDetails(productJson, productId,currentBtn);
    }
  });

  /*- Modal Opener -*/
  $(document).on("click", ".open-addToCart-modal", function(){
    let productJson = JSON.parse($(this).parents(".product-block__info").find(".color-swatch__option.active script").html());
    console.log(productJson);
    $(".modal_product_title").text((productJson.title).split("|")[0]);
    $(".modal_product_varient").html(`<span>${(productJson.title).split("|")[1]}</span><span class="modal-selected-size"></span>`);
    $(".modal_product_action form").attr("data-product-id", productJson.id);
    const getPadding = (aspectRatio)=>{
      let padding = 1;
      return ((padding / aspectRatio)* 100 )
    }
    let firstImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${productJson.media[0].width} px">
<div class="rimage-wrapper " style="padding-top:${getPadding(productJson.media[0].aspect_ratio)}%">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""
data-srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${productJson.media[0].src}_1024x1024.png?v=1626405866" alt="${productJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
    $(".modal_product_image").empty().append(firstImageHtml);

    $(".modal_product_detail").attr("href",`/products/${productJson.handle}`);

    let price = productJson.price - 2000;
    $(".modal_product_price").text(`${(theme.Shopify.formatMoney(price,theme.money_format)).replace(".00", "")} + ${(theme.Shopify.formatMoney(2000,theme.money_format)).replace(".00", "")} Recycling Credit`);


    /* For Size */
    $(".modal_product_size .size_swatched").empty();
    let count = 0;
    let availableClass = "";
    for(let variant of productJson.variants){
      count++;
      variant.available ? availableClass = "": availableClass = "unavailable";
      let sizeBoxHtml = `<li data-tag="${variant.title}" class="${availableClass}"><button type="button" data-variant-title="${variant.title}" data-variant-id="${variant.id}" class="select-a-size not-a-button ${availableClass}">${variant.title}</button></li>`;
      $(".modal_product_size .size_swatched").append(sizeBoxHtml);
      //<option value="39274213310551" deny="" data-stock="out">5</option>
      $('.modal_product_action select[name="id"]').append($('<option>', {
        "value": variant.id,
        "data-title": variant.title,
        "data-available": variant.available,
        "text": variant.title,
        "disabled":!variant.available
      }));
    }

    //theme.applyAjaxToProductForm($(".modal_product_action form#collection-form"));

    $(`#collection-modal`).fadeIn("1000");
    $(`#collection-modal`).addClass("active")
    $("body").addClass("collection_modal_overlay");

  });

  /*- Modal Closer -*/
  $(document).on("click", "#collection-modal .close",function(){
    $(`#collection-modal`).fadeOut("1000");
    $(`#collection-modal`).removeClass("active")
    $("body").removeClass("collection_modal_overlay");
    $(".modal_product_button_size").show();
    $(".modal_product_button").hide();
    $(".modal_product_size_title span").text("Select a size");
  });

  /*- Size Click Event Handler -*/
  $(document).on("click", ".select-a-size", function(){
    $(".select-a-size").parent("li").removeClass("active");
    let variantId = $(this).data("variant-id");
    let variantTitle = $(this).data("variant-title");
    $(this).parent("li").addClass("active");
    if($(this).hasClass("unavailable")){
      $(".modal_product_button_size").show();
      $(".modal_product_button").hide();
    }else{
      $(".modal_product_button_size").hide();
      $(".modal_product_button").show();

      $(this).parents(".modal_body").find("select[name='id']").val(variantId);
      $(this).parents(".modal_body").find("select[name='id'] option").removeAttr("selected");
      $(this).parents(".modal_body").find("select[name='id'] option:selected").attr("selected", "selected");
    }


    console.log($(this).parents(".modal_body").find("select[name='id']").val());

    $(".modal_product_size_title span").text(variantTitle);
  });

  $(document).on("click", ".modal_product_button", function(e){
    //e.preventDefault();
    let form = $(this).parents(".modal_product_action").find("form#collection-form");
    console.log($(this).parents(".modal_product_action").find("form#collection-form"));
    //theme.applyAjaxToProductForm(form);
  });

  $(document).on("submit", ".modal_product_action form#collection-form", function(event){
    event.preventDefault();
    console.log($(this).serialize());
    var $form = $(this);
    var $btn = $(this).find('[type=submit]').attr('disabled', 'disabled').addClass('confirmation adding');
    var shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';
    var shopifyAjaxStorePageURL = theme.routes.search_url;
    $btn.html(theme.strings.productAddingToCart);

    $.post(shopifyAjaxAddURL, $form.serialize(), function (itemData) {
      $.get(shopifyAjaxStorePageURL, function (data) {
        document.dispatchEvent(new CustomEvent('mini-cart:open'));
        document.dispatchEvent(new CustomEvent('mini-cart:refresh'));
        var cartSummarySelector = '#site-control .cart:not(.nav-search)';
        var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartSummarySelector);
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
        $('#site-control').find('[data-cc-animate]').removeAttr('data-cc-animate');


        //Change Btn Text to Added..
        $btn.html(theme.icons.tick + ' ' + theme.strings.productAddedToCart);


        //Change text back to Add To Cart
        setTimeout(function(){
          $btn.removeAttr('disabled').removeClass('confirmation').html(theme.strings.buttonDefault);

          //Close Modal Pop Up
          if($(document).find(".modal_close.close").length){
            $(document).find(".modal_close.close").click();
          }
          //Open Cart Drawer
          //console.log($(document).find(".side_cart").hasClass("cart-active"));
          if(!$(document).find(".side_cart").hasClass("cart-active")){
            $(document).find(".side_cart").click();
          }
          //Close Modal Pop Up
          //           if($(document).find(".modal_close.close").length){
          //             $(document).find(".modal_close.close").click();
          //           }
        },2500);





      });
    }, 'text')
    .fail(function (data) {
      console.log(data.responseText)
      $btn.removeAttr('disabled').removeClass('confirmation').html(theme.strings.buttonDefault);
    });

  });
});
